export default {
  layoutHeader(state) {
    return state.layout.header
  },
  navbarOpen(state) {
    return state.layout.navbarOpen
  },
  // Topかどうか知る
  isTop(state) {
    return state.layout.isTop
  },
  scroll200(state) {
    return state.layout.scroll.scroll200
  },
  loading: state => state.layout.loading,
}
